// Broker challenge client (ADR-0064).
export type ChallengeResult =
  | { kind: 'redirect', redirectUrl: string }
  | { kind: 'error' }

export interface ChallengeRequest {
  email: string
  returnUrl: string | null
  endpoint: string
  fetchImpl?: typeof fetch
}

// One generic failure for every failing email.
const GENERIC_FAILURE: ChallengeResult = { kind: 'error' }

export async function submitChallenge({
  email,
  returnUrl,
  endpoint,
  fetchImpl = globalThis.fetch,
}: ChallengeRequest): Promise<ChallengeResult> {
  const body: Record<string, string> = { email }
  if (returnUrl !== null) {
    body.returnUrl = returnUrl
  }

  try {
    const response = await fetchImpl(endpoint, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
    })

    const payload: unknown = await response.json()
    const redirectUrl = (payload as { redirectUrl?: unknown } | null)?.redirectUrl

    if (!response.ok || typeof redirectUrl !== 'string' || redirectUrl === '') {
      return GENERIC_FAILURE
    }

    return { kind: 'redirect', redirectUrl }
  }
  catch {
    return GENERIC_FAILURE
  }
}
